export default __webpack_public_path__ + "static/media/0236.7dca32d0.jpg";